export default __webpack_public_path__ + "static/media/019-shooting gallery.9a81d2fd.svg";